// import { WardApiClient } from '@/common/services/api/ward-backend/client';
import { BffApiClient } from '@/common/services/api/bffClient';
import { userEndpoints } from '../endpoints/userEndoints';
import { User } from '../../types/userTypes';
import { logger } from '@/common/services/config';

export class UserService {
  private static get api() {
    return BffApiClient.getInstance();
  }

  static async getUser(): Promise<User | null> {
    try {
      const response = await this.api.get(userEndpoints.getUser);
      return response.data as User;
    } catch (error) {
      logger.error('Error fetching user avatar:', error);
      return null;
    }
  }
}
